import { Action } from '@ngrx/store'

import { AutocompleteItem } from '../../../shared/autocomplete/autocomplete-item'
import {
  ConversationExtended, ConversationType, JeanMessageConfirmationType,
  MessageExtended
} from '../../../shared/conversation'
import { ConversationAssignedIE, TeamMemberCreatedIE, TeamMemberDeletedIE, VendorTeamCreatedIE } from '../../../shared/signalR/models'
import { ClientEvent, VendorEvent } from '../../../shared/signalR/models/events'
import {
  ConversationClosedIE,
  ConversationOpenIE
} from '../../../shared/signalR/models/integration-events'
import { VendorMessageRequest } from '../../../shared/signalR/models/messages'
import { TypingUser } from '../../../shared/conversation/typing.user'
import { AssigneesV1 } from '../../../api/api/models/assignees-v1'
import { VendorTeamDeactivatedIE, VendorTeamActivatedIE } from '../../../shared/signalR/models/integration-events/vendor-team-active-ie'

export const LOAD_ASSIGNEES = '[Chat] load assignees'
export const LOAD_ASSIGNEES_SUCCESS = '[Chat] load assignees success'

export const SET_ASSIGN_LEFT_POSITION = '[Chat] set assign left pos'
export const TOGGLE_ASSIGN_OPEN = '[Chat] toggle assign open'

export const ASSIGN_CONVERSATION = '[Chat] assign conversation'

export const CLOSE_CONVERSATION = '[Chat] close conversation'
export const CLOSE_CONVERSATION_SUCCESS = '[Chat] close conversation success'

export const NEXT_CONVERSATIONS_PAGE = '[Chat] next conversations page'
export const NEXT_CONVERSATIONS_PAGE_SUCCESS = '[Chat] next conversations page success'
export const NEXT_CONVERSATIONS_PAGE_FAILURE = '[Chat] next conversations page failure'

export const FIRST_CONVERSATIONS_PAGE = '[Chat] first conversations page'
export const FIRST_CONVERSATIONS_PAGE_SUCCESS = '[Chat] first conversations page success'
export const FIRST_CONVERSATIONS_PAGE_FAILURE = '[Chat] first conversations page failure'

export const LAST_MESSAGE_SEEN = '[Chat] last msg seen'
export const REMOVE_CONVERSATION = '[Chat] remove conversation'
export const ADD_MESSAGE = '[Chat] add message'
export const ADD_MESSAGE_DONE = '[Chat] add message done'
export const MESSAGE_SENT = '[Chat] message sent'
export const RECEIVE_MESSAGE = '[Chat] receive message'
export const PLAY_RECEIVE_MESSAGE = '[Chat] play receive message'

export const NEXT_MESSAGES_PAGE = '[Chat] next messages page'
export const NEXT_MESSAGES_PAGE_SUCCESS = '[Chat] next messages page success'
export const NEXT_MESSAGES_PAGE_FAILURE = '[Chat] next messages page failure'

export const FIRST_MESSAGES_PAGE = '[Chat] first messages page'
export const FIRST_MESSAGES_PAGE_SUCCESS = '[Chat] first messages page success'
export const FIRST_MESSAGES_PAGE_FAILURE = '[Chat] first messages page failure'

export const START_TYPING_RECEIVED = '[Chat] start typing received'
export const STOP_TYPING_RECEIVED = '[Chat] stop typing received'
export const START_TYPING = '[Chat] start typing'
export const STOP_TYPING = '[Chat] stop typing'
export const SET_CURRENT_CONVERSATION = '[Chat] set current conversation'

export const LOAD_CONVERSATION = '[Chat] load conversation'
export const LOAD_CONVERSATION_SUCCESS = '[Chat] load conversation success'

export const SET_MESSAGE_CONFIRMATION = '[Chat] set message confirmation'
export const NACK_MESSAGE = '[Chat] Nack message'
export const SEND_MESSAGE = '[Chat] send message'
export const CHANGE_CONVERSATION_FILTER = '[Chat] change conv filter'
export const RELOAD_CONVERSATIONS = '[Chat] reload conversations'

export const CONVERSATION_UNASSIGNED_EVENT = '[Chat] conv unassigned event'
export const CONVERSATION_ASSIGNED_EVENT = '[Chat] conv assigned event'
export const CONVERSATION_CLOSED_EVENT = '[Chat] conv closed event'
export const CONVERSATION_OPEN_EVENT = '[Chat] conv open event'
export const TEAM_MEMBER_CREATED_EVENT = '[Chat] team member created event'
export const TEAM_MEMBER_DELETED_EVENT = '[Chat] team member deleted event'
export const VENDOR_TEAM_CREATED_EVENT = '[Chat] vendor team created event'
export const VENDOT_TEAM_ACTIVATED_EVENT = '[Chat] vendor team activated event'
export const VENDOT_TEAM_DEACTIVATED_EVENT = '[Chat] vendor team deactivated event'

export const LOAD_CONVERSATIONS_ROUTED = '[Chat] load conversations routed'
export const LOAD_MESSAGES_ROUTED = '[Chat] load messages routed'

export const SET_CURRENT_CONVERSATION_ASSIGNEE = '[Chat] set current conversation assignee'

export class LoadAssignees implements Action {
  readonly type = LOAD_ASSIGNEES

  constructor(public payload: { force?: boolean } = {force: false}) {
  }
}

export class LoadAssigneesSuccess implements Action {
  readonly type = LOAD_ASSIGNEES_SUCCESS

  constructor(public payload: AssigneesV1) {
  }
}

export class SetAssignLeftPosition implements Action {
  readonly type = SET_ASSIGN_LEFT_POSITION

  constructor(public payload: number) {
  }
}

export class ToggleAssignOpen implements Action {
  readonly type = TOGGLE_ASSIGN_OPEN

  constructor(public payload: boolean) {
  }
}


export class AssignConversation implements Action {
  readonly type = ASSIGN_CONVERSATION

  constructor(public payload: { assignee: AutocompleteItem }) {
  }
}

export class CloseConversation implements Action {
  readonly type = CLOSE_CONVERSATION
}

export class CloseConversationSuccess implements Action {
  readonly type = CLOSE_CONVERSATION_SUCCESS

  constructor(public payload: string) {
  }
}

export class NextConversationsPage implements Action {
  readonly type = NEXT_CONVERSATIONS_PAGE

  constructor(public payload: string) {
  }
}

export class NextConversationsPageSuccess implements Action {
  readonly type = NEXT_CONVERSATIONS_PAGE_SUCCESS

  constructor(public payload: { conversations: ConversationExtended[], paging: any }) {
  }
}

export class NextConversationsPageFailure implements Action {
  readonly type = NEXT_CONVERSATIONS_PAGE_FAILURE

  constructor(public payload: any) {
  }
}

export class FirstConversationsPage implements Action {
  readonly type = FIRST_CONVERSATIONS_PAGE

  constructor(public payload: { url: string, vendorTeamId?: number, open: boolean }) {
  }
}

export class FirstConversationsPageSuccess implements Action {
  readonly type = FIRST_CONVERSATIONS_PAGE_SUCCESS

  constructor(public payload: { conversations: ConversationExtended[], paging: any }) {
  }
}

export class FirstConversationsPageFailure implements Action {
  readonly type = FIRST_CONVERSATIONS_PAGE_FAILURE

  constructor(public payload: any) {
  }
}

export class LastMessageSeen implements Action {
  readonly type = LAST_MESSAGE_SEEN

  constructor(public payload: { event: ClientEvent | VendorEvent, isSentByClient: boolean }) {
  }
}

export class RemoveConversation implements Action {
  readonly type = REMOVE_CONVERSATION

  constructor(public payload: { conversationId: string }) {
  }
}

export class AddMessage implements Action {
  readonly type = ADD_MESSAGE

  constructor(public payload: { messageText: string }) {
  }
}

export class AddMessageDone implements Action {
  readonly type = ADD_MESSAGE_DONE

  constructor(public payload: { conversationId: string, message: MessageExtended }) {
  }
}

export class MessageSent implements Action {
  readonly type = MESSAGE_SENT

  constructor(public payload: any) {
  }
}

export class ReceiveMessage implements Action {
  readonly type = RECEIVE_MESSAGE

  constructor(public payload: { conversationId: string, message: MessageExtended }) {
  }
}

export class PlayReceiveMessage implements Action {
  readonly type = PLAY_RECEIVE_MESSAGE

  constructor(public payload: { message: MessageExtended }) {
  }
}

export class NextMessagesPage implements Action {
  readonly type = NEXT_MESSAGES_PAGE

  constructor(public payload: string) {
  }
}

export class NextMessagesPageSuccess implements Action {
  readonly type = NEXT_MESSAGES_PAGE_SUCCESS

  constructor(public payload: { messages: MessageExtended[], paging: any }) {
  }
}

export class NextMessagesPageFailure implements Action {
  readonly type = NEXT_MESSAGES_PAGE_FAILURE

  constructor(public payload: any) {
  }
}

export class FirstMessagesPage implements Action {
  readonly type = FIRST_MESSAGES_PAGE

  constructor(public payload: { url: string }) {
  }
}

export class FirstMessagesPageSuccess implements Action {
  readonly type = FIRST_MESSAGES_PAGE_SUCCESS

  constructor(public payload: { messages: MessageExtended[], paging: any }) {
  }
}

export class FirstMessagesPageFailure implements Action {
  readonly type = FIRST_MESSAGES_PAGE_FAILURE

  constructor(public payload: any) {
  }
}

export class StartTypingReceived implements Action {
  readonly type = START_TYPING_RECEIVED

  constructor(public payload: { typingUser: TypingUser, isUser: boolean }) {
  }
}

export class StopTypingReceived implements Action {
  readonly type = STOP_TYPING_RECEIVED

  constructor(public payload: { typingUser: TypingUser, isUser: boolean }) {
  }
}

export class StartTyping implements Action {
  readonly type = START_TYPING

  constructor(public payload: any) {
  }
}

export class StopTyping implements Action {
  readonly type = STOP_TYPING

  constructor(public payload: any) {
  }
}

export class SetCurrentConversation implements Action {
  readonly type = SET_CURRENT_CONVERSATION

  constructor(public payload: { currentConversation: ConversationExtended }) {
  }
}

export class LoadConversation implements Action {
  readonly type = LOAD_CONVERSATION

  constructor(public payload: { conversationId: string, vendorTeamId: number, conversationType: ConversationType }) {
  }
}

export class LoadConversationSuccess implements Action {
  readonly type = LOAD_CONVERSATION_SUCCESS

  constructor(public payload: { conversation: ConversationExtended }) {
  }
}

export class SetMessageConfirmation implements Action {
  readonly type = SET_MESSAGE_CONFIRMATION

  constructor(public payload: { messageId: string, confirmationType: JeanMessageConfirmationType }) {
  }
}

export class NackMessage implements Action {
  readonly type = NACK_MESSAGE

  constructor(public payload: { messageId: string }) {
  }
}

export class SendMessage implements Action {
  readonly type = SEND_MESSAGE

  constructor(public payload: { message: VendorMessageRequest }) {
  }
}

export class ChangeConversationFilter implements Action {
  readonly type = CHANGE_CONVERSATION_FILTER

  constructor(public payload: { conversationType: ConversationType, vendorTeamId?: number, vendorUserId?: number, reload: boolean }) {
  }
}

export class ReloadConversations implements Action {
  readonly type = RELOAD_CONVERSATIONS

  constructor(public payload: { conversationType?: ConversationType, vendorTeamId?: number, vendorUserId: number }) {
  }
}

// events
export class ConversationAssignedEvent implements Action {
  readonly type = CONVERSATION_ASSIGNED_EVENT

  constructor(public payload: { event: ConversationAssignedIE }) {
  }
}

export class ConversationClosedEvent implements Action {
  readonly type = CONVERSATION_CLOSED_EVENT

  constructor(public payload: { event: ConversationClosedIE }) {
  }
}

export class ConversationOpenEvent implements Action {
  readonly type = CONVERSATION_OPEN_EVENT

  constructor(public payload: { event: ConversationOpenIE }) {
  }
}

export class TeamMemberCreatedEvent implements Action {
  readonly type = TEAM_MEMBER_CREATED_EVENT

  constructor(public payload: { event: TeamMemberCreatedIE }) {
  }
}

export class TeamMemberDeletedEvent implements Action {
  readonly type = TEAM_MEMBER_DELETED_EVENT

  constructor(public payload: { event: TeamMemberDeletedIE }) {
  }
}

export class VendorTeamCreatedEvent implements Action {
  readonly type = VENDOR_TEAM_CREATED_EVENT

  constructor(public payload: { event: VendorTeamCreatedIE }) {
  }
}

export class VendorTeamActivatedEvent implements Action {
  readonly type = VENDOT_TEAM_ACTIVATED_EVENT

  constructor(public payload: { event: VendorTeamActivatedIE }) {
  }
}

export class VendorTeamDeactivatedEvent implements Action {
  readonly type = VENDOT_TEAM_DEACTIVATED_EVENT

  constructor(public payload: { event: VendorTeamDeactivatedIE }) {
  }
}

// routing
export class LoadConversationsRouted implements Action {
  readonly type = LOAD_CONVERSATIONS_ROUTED

  constructor(public payload: { msgsUrl: string , vendorTeamId: number, vendorUserId?: number }) {
  }
}

export class LoadMessagesRouted implements Action {
  readonly type = LOAD_MESSAGES_ROUTED

  constructor(public payload: { msgsUrl: string }) {
  }
}

export class SetCurrentConversationAssignee implements Action {
  readonly type = SET_CURRENT_CONVERSATION_ASSIGNEE

  constructor(public payload: { vendorTeamId: number, vendorUserId?: number, conversationId: string }) {
  }
}

export type Actions =
  LoadAssignees
  | LoadAssigneesSuccess
  | ToggleAssignOpen
  | SetAssignLeftPosition
  | AssignConversation
  | CloseConversation
  | CloseConversationSuccess
  | FirstConversationsPage
  | FirstConversationsPageSuccess
  | FirstConversationsPageFailure
  | NextConversationsPage
  | NextConversationsPageSuccess
  | NextConversationsPageFailure
  | LastMessageSeen
  | AddMessage
  | AddMessageDone
  | MessageSent
  | RemoveConversation
  | ReceiveMessage
  | PlayReceiveMessage
  | FirstMessagesPage
  | FirstMessagesPageSuccess
  | FirstMessagesPageFailure
  | NextMessagesPage
  | NextMessagesPageSuccess
  | NextMessagesPageFailure
  | StartTypingReceived
  | StartTyping
  | StopTypingReceived
  | StopTyping
  | SetCurrentConversation
  | LoadConversation
  | LoadConversationSuccess
  | SetMessageConfirmation
  | NackMessage
  | SendMessage
  | ChangeConversationFilter
  | ReloadConversations
  | ConversationAssignedEvent
  | ConversationClosedEvent
  | ConversationOpenEvent
  | TeamMemberCreatedEvent
  | TeamMemberDeletedEvent
  | VendorTeamCreatedEvent
  | VendorTeamActivatedEvent
  | VendorTeamDeactivatedEvent
  | LoadConversationsRouted
  | LoadMessagesRouted
  | SetCurrentConversationAssignee



// WEBPACK FOOTER //
// ./src/app/chat/store/actions/chat.actions.ts